// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-detail-container.show-modal-detail .modal-detail {
  animation: show-modal 0.5s ease forwards;
}
.modal-detail-container.show-modal-detail .modal-detail-mask {
  animation: show-modal-mask 0.5s ease forwards;
}
.modal-detail-container.hide-modal-detail .modal-detail {
  visibility: hidden;
}
.modal-detail-container.hide-modal-detail .modal-detail-mask {
  visibility: hidden;
}
.modal-detail-container:not(.show-modal-detail) .modal-detail {
  animation: hide-modal 0.3s ease forwards;
}
.modal-detail-container:not(.show-modal-detail) .modal-detail-mask {
  animation: hide-modal 0.3s ease forwards;
}
.modal-detail-container .modal-detail-mask {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
}
.modal-detail-container .modal-detail {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 800px;
  height: auto;
  padding: 20px;
  background-color: #fff;
  z-index: 101;
  box-shadow: 0px 0px 10px #cccccc;
  border-radius: 9px;
  transform: translate(-50%, -50%) scale(0);
}

@media (max-width: 550px) {
  .modal-detail-container .modal-detail {
    width: calc(100vw - 40px);
  }
}
@media (max-width: 800px) {
  .modal-detail-container .modal-detail {
    width: calc(100% - 40px);
  }
}
@keyframes show-modal {
  0% {
    transform: translate(-50%, -50%) scale(0.7);
    -webkit-transform: translate(-50%, -50%) scale(0.7);
  }
  100% {
    transform: translate(-50%, -50%) scale(1.05);
    -webkit-transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    transform: translate(-50%, -50%) scale(0.95);
    -webkit-transform: translate(-50%, -50%) scale(0.95);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
  }
}
@keyframes show-modal-mask {
  0% {
    opacity: 0;
    visibility: visible;
  }
  100% {
    opacity: 1;
    visibility: visible;
  }
}
@keyframes hide-modal {
  0% {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
  }
  0% {
    transform: translate(-50%, -50%) scale(0.95);
    -webkit-transform: translate(-50%, -50%) scale(0.95);
  }
  0% {
    transform: translate(-50%, -50%) scale(1.05);
    -webkit-transform: translate(-50%, -50%) scale(1.05);
  }
  100% {
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%, -50%) scale(0.7);
    -webkit-transform: translate(-50%, -50%) scale(0.7);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modal-detail-doc/modal-detail-doc.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAGQ;EACI,wCAAA;AAFZ;AAKQ;EACI,6CAAA;AAHZ;AAOQ;EACI,kBAAA;AALZ;AAQQ;EACI,kBAAA;AANZ;AAUQ;EACI,wCAAA;AARZ;AAWQ;EACI,wCAAA;AATZ;AAaI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,YAAA;AAXR;AAaI;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBCvBA;EDwBA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,yCAAA;AAXR;;AAeA;EACI;IACI,yBAAA;EAZN;AACF;AAeA;EACE;IACI,wBAAA;EAbJ;AACF;AAgBA;EACI;IACI,2CAAA;IACA,mDAAA;EAdN;EAgBE;IACI,4CAAA;IACA,oDAAA;EAdN;EAgBE;IACI,4CAAA;IACA,oDAAA;EAdN;EAgBE;IACI,yCAAA;IACA,iDAAA;EAdN;AACF;AAiBA;EACI;IACI,UAAA;IACA,mBAAA;EAfN;EAiBE;IACI,UAAA;IACA,mBAAA;EAfN;AACF;AAkBA;EACI;IACI,yCAAA;IACA,iDAAA;EAhBN;EAkBE;IACI,4CAAA;IACA,oDAAA;EAhBN;EAkBE;IACI,4CAAA;IACA,oDAAA;EAhBN;EAkBE;IACI,UAAA;IACA,kBAAA;IACA,2CAAA;IACA,mDAAA;EAhBN;AACF","sourcesContent":["@import './../../../../sass/variables';\n.modal-detail-container {\n    &.show-modal-detail {\n        .modal-detail {\n            animation: show-modal 0.5s ease forwards;\n\n        }\n        .modal-detail-mask {\n            animation: show-modal-mask 0.5s ease forwards;\n        }\n    }\n    &.hide-modal-detail {\n        .modal-detail {\n            visibility: hidden;\n\n        }\n        .modal-detail-mask {\n            visibility: hidden;\n        }\n    }\n    &:not(.show-modal-detail) {\n        .modal-detail {\n            animation: hide-modal 0.3s ease forwards;\n\n        }\n        .modal-detail-mask {\n            animation: hide-modal 0.3s ease forwards;\n        }\n    }\n\n    .modal-detail-mask {\n        visibility: hidden;\n        opacity: 0;\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba($white, 0.8);\n        z-index: 100;\n    }\n    .modal-detail {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        width: 800px;\n        height: auto;\n        padding: 20px;\n        background-color: $white;\n        z-index: 101;\n        box-shadow: 0px 0px 10px $cinza-400;\n        border-radius: 9px;\n        transform: translate(-50%, -50%) scale(0);\n    }\n}\n\n@media (max-width: 550px) {\n    .modal-detail-container .modal-detail {\n        width: calc(100vw - 40px);\n    }\n}\n\n@media (max-width: 800px) {\n  .modal-detail-container .modal-detail {\n      width: calc(100% - 40px);\n  }\n}\n\n@keyframes show-modal {\n    0% {\n        transform: translate(-50%, -50%) scale(0.7);\n        -webkit-transform: translate(-50%, -50%) scale(0.7);\n    }\n    100% {\n        transform: translate(-50%, -50%) scale(1.05);\n        -webkit-transform: translate(-50%, -50%) scale(1.05);\n    }\n    100% {\n        transform: translate(-50%, -50%) scale(0.95);\n        -webkit-transform: translate(-50%, -50%) scale(0.95);\n    }\n    100% {\n        transform: translate(-50%, -50%) scale(1);\n        -webkit-transform: translate(-50%, -50%) scale(1);\n    }\n}\n\n@keyframes show-modal-mask {\n    0% {\n        opacity: 0;\n        visibility: visible;\n    }\n    100% {\n        opacity: 1;\n        visibility: visible;\n    }\n}\n\n@keyframes hide-modal {\n    0% {\n        transform: translate(-50%, -50%) scale(1);\n        -webkit-transform: translate(-50%, -50%) scale(1);\n    }\n    0% {\n        transform: translate(-50%, -50%) scale(0.95);\n        -webkit-transform: translate(-50%, -50%) scale(0.95);\n    }\n    0% {\n        transform: translate(-50%, -50%) scale(1.05);\n        -webkit-transform: translate(-50%, -50%) scale(1.05);\n    }\n    100% {\n        opacity: 0;\n        visibility: hidden;\n        transform: translate(-50%, -50%) scale(0.7);\n        -webkit-transform: translate(-50%, -50%) scale(0.7);\n    }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
